/**
 * Field types for Dragon theme
 */
export enum ISPFieldType {
  GeneralError = 'generalError',
  Input = 'input',
  Skeleton = 'skeleton',
  OTP = 'otp',
  DatePicker = 'datepicker',
  Select = 'select',
  AutocompleteSelect = 'autocomplete',
  Radio = 'radio',
  RadioImg = 'radioimg',
  Reflect = 'reflect',
  Switcher = 'switcher',
  SwitcherSelect = 'switcherSelect',
  TotalSum = 'totalsum',
  Checkbox = 'checkbox',
  ColorPicker = 'colorpicker',
  Hidden = 'hidden',
  TextData = 'textdata',
  Frame = 'frame',
  List = 'list',
  ListFilter = 'listfilter',
  Slider = 'slider',
  Link = 'link',
  Button = 'button',
  Banner = 'banner',
  Password = 'password',
  PromoCode = 'promocode',
  TextArea = 'textarea',
  Phone = 'phone',
  File = 'file',
  Tree = 'tree',
  Toolbar = 'toolbar',
  Code = 'code',
  DateTime = 'datetime',
  Group = 'group',
  Template = 'template',
  DefaultLayout = 'defaultLayout',
  CardLayout = 'cardLayout',
  MiniLayout = 'miniLayout',
  ExtformLayout = 'extformLayout',
  Chat = 'ticket',
  Captcha = 'captcha',
  ChatSummary = 'ticketinfo',
  FormScroller = 'scroller',
  TextEditor = 'texteditor',
  Wizard = 'wizard',
}

/**
 * All field types with form controls
 */
export type ISPFieldTypeWithControl = Exclude<
  ISPFieldType,
  | ISPFieldType.Button
  | ISPFieldType.CardLayout
  | ISPFieldType.ChatSummary
  | ISPFieldType.DefaultLayout
  | ISPFieldType.ExtformLayout
  | ISPFieldType.FormScroller
  | ISPFieldType.GeneralError
  | ISPFieldType.Group
  | ISPFieldType.ListFilter
  | ISPFieldType.MiniLayout
  | ISPFieldType.Template
  | ISPFieldType.Toolbar
  | ISPFieldType.Wizard
>;

export type ISPFieldTypeLayout =
  | ISPFieldType.CardLayout
  | ISPFieldType.DefaultLayout
  | ISPFieldType.ExtformLayout
  | ISPFieldType.MiniLayout;
